import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import actionsSession from '@/app/modules/session/api/actionsSession';
import useSessionStore from '@/app/store/session';

/**
 * A hook to check url queries and handle mfa deactiovation confirmation
 * @param {boolean} showModalDeactivationMfaConfirmation
 * @param {function} setShowModalDeactivationMfaConfirmation
 * @param {function} setMfaDeactivationResponse
 * @param {function} setShowModalSecureAccess
 * @param {boolean} showModalSecureAccess
 * @returns {void}
 */
const useMfaCheck = (showModalDeactivationMfaConfirmation, setShowModalDeactivationMfaConfirmation,
    setMfaDeactivationResponse, setShowModalSecureAccess, showModalSecureAccess) => {
    //Store
    const { storeNewAccount, newAccount } = useSessionStore();

    // Query params
    const [searchParams] = useSearchParams();
    const deactivateMfa = searchParams.get('deactivateMfa') === 'true';
    const token = searchParams.get('token');

    // API calls
    const onError = () => {
        setMfaDeactivationResponse({ isLoading: false, responseEntity: 'mfa.deactivation_error' });
    };
    const onSuccess = () => {
        setMfaDeactivationResponse({ isLoading: false, responseEntity: 'mfa.deactivation_success' });
    };
    const mfaDeactivationConfirmation = actionsSession.mfaDeactivationConfirmation(onSuccess, onError);

    // Hook
    useEffect(() => {
        if (!showModalDeactivationMfaConfirmation && deactivateMfa && token) {
            mfaDeactivationConfirmation.mutate({ resourceActionTokenUuid: token });
            setShowModalDeactivationMfaConfirmation(true);
        }
        if (mfaDeactivationConfirmation.isLoading) {
            setMfaDeactivationResponse({ isLoading: true, responseEntity: null });
        }
    }, [searchParams]);

    useEffect(() => {
        if (newAccount) {
            setShowModalSecureAccess(true);
            storeNewAccount(false);
        }
    }, [showModalSecureAccess, newAccount]);
};

export default useMfaCheck;